var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.223 19.29h-.001c-2.595-2.354-4.668-4.236-6.104-5.992C3.693 11.556 3 10.062 3 8.5 3 5.972 4.972 4 7.5 4c1.437 0 2.832.674 3.739 1.738l.761.894.761-.894C13.668 4.674 15.063 4 16.5 4 19.028 4 21 5.972 21 8.5c0 1.562-.693 3.056-2.118 4.8-1.436 1.757-3.509 3.64-6.103 5.999h-.002l-.774.701-.78-.71Z"
  })));
};
export default SvgHeart;